import access from './access';
import archiveMaintenance from './archiveMaintenance';
import conversion from './conversion';
import dashboard from './dashboard';
import email from './email';
import error from './error';
import event from './event';
import _export from './export';
import filebrowser from './filebrowser';
import forms from './forms';
import general from './general';
import _import from './import';
import ip from './ip';
import keyboardShortcuts from './keyboardShortcuts';
import media from './media';
import notifications from './notifications';
import organization from './organization';
import stateTree from './stateTree';
import sysInfo from './sysinfo';
import upload from './upload';
import userSettings from './userSettings';

export default [
  access,
  archiveMaintenance,
  conversion,
  dashboard,
  email,
  error,
  event,
  _export,
  filebrowser,
  forms,
  general,
  _import,
  ip,
  keyboardShortcuts,
  media,
  notifications,
  organization,
  stateTree,
  sysInfo,
  upload,
  userSettings,
];
